import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { CreateRoleWidget } from '@/widgets/role-item-widget'

export const Route = createFileRoute('/_auth/users/create-role')({
  staticData: {
    meta: {
      title: 'Создание роли',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Создание роли')}>
      <CreateRoleWidget mode="create" />
    </PageWrapper>
  )
}
